import React, { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import {
  Command, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem,
} from "./ui/command";
import { Button } from "./ui/button";
import { Check, ChevronsUpDown, Clock } from "lucide-react";
import { TIMEZONES, offsetLabel, tzMeta } from "../lib/timezone";

export default function TimezoneSelect({ value, onChange, testid = "timezone-select" }) {
  const [open, setOpen] = useState(false);
  const meta = tzMeta(value);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          role="combobox"
          data-testid={testid}
          className="w-full justify-between font-normal"
        >
          <span className="flex items-center gap-2 truncate">
            <Clock className="h-4 w-4 shrink-0 text-slate-400" />
            {value ? (
              <span className="truncate">
                {meta.label} — {value}
                <span className="ml-2 text-xs text-slate-400">{offsetLabel(value)}</span>
              </span>
            ) : (
              <span className="text-slate-400">Select organization timezone…</span>
            )}
          </span>
          <ChevronsUpDown className="h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] min-w-[320px] p-0" align="start">
        <Command
          filter={(val, search) => (val.toLowerCase().includes(search.toLowerCase()) ? 1 : 0)}
        >
          <CommandInput placeholder="Search city, region or UTC offset…" data-testid={`${testid}-search`} />
          <CommandList>
            <CommandEmpty>No timezone found.</CommandEmpty>
            <CommandGroup>
              {TIMEZONES.map((t) => (
                <CommandItem
                  key={t.tz}
                  value={`${t.tz} ${t.label} ${offsetLabel(t.tz)}`}
                  data-testid={`tz-option-${t.tz}`}
                  onSelect={() => { onChange(t.tz); setOpen(false); }}
                >
                  <Check className={`mr-2 h-4 w-4 ${value === t.tz ? "opacity-100" : "opacity-0"}`} />
                  <span className="flex-1">
                    <span className="font-medium text-slate-800">{t.label}</span>
                    <span className="ml-2 text-xs text-slate-500">{t.tz}</span>
                  </span>
                  <span className="text-xs text-slate-400">{offsetLabel(t.tz)}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
